import React, { useState } from 'react'
import styled from 'styled-components'
import { IRemarkData } from './ArizotViewMain'
import ImageComponentHead from '../../../../../generic/imageComponents/ImageComponentHead'
import Image from '../../../../../generic/assets/collect.png'
import { FormShell, FormField, FormFooter } from '../../../../../generic/ui/FormLayout'
import { AccentButton } from '../../../../../generic/ui/Button/AccentButton'
import { useTranslation } from 'react-i18next'

type Props = {
    data: IRemarkData,
    close: () => void,
    isActive?: boolean,
    handleSave?: (input: string) => void
}

const RemarkModal = ({data, close, isActive, handleSave}: Props) => {
    const [t] = useTranslation(['packageOrder', 'buttons'])
    const [input, setInput] = useState<string>(data?.body?.trim() || '')
    const remarkHandle = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setInput(e.target.value)
    }
    const handleSaveRemark = () => {
        if(!handleSave) return
        handleSave(input)
    }
  return (
    <FormShell>
        <ImageComponentHead img={Image} />
        <FormField label='הערה' fullWidth>
            <RemarkArea
                rows={8}
                readOnly={!isActive}
                defaultValue={input}
                onChange={remarkHandle}
            />
        </FormField>
        {
            isActive &&
            <FormFooter>
                <AccentButton
                    type='button'
                    onClick={handleSaveRemark}
                    fullWidth={false}
                >
                    {t('buttons:save')}
                </AccentButton>
            </FormFooter>
        }
    </FormShell>
  )
}

const RemarkArea = styled.textarea`
  width: 100%;
  min-height: 9rem;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.inputBorder};
  border-radius: 0.875rem;
  padding: 0.625rem 0.875rem;
  font-family: ${({ theme }) => theme.fonts.sans};
  font-size: ${({ theme }) => theme.text.lg};
  color: ${({ theme }) => theme.colors.ink};
  outline: none;
  resize: vertical;
  direction: rtl;
  transition:
    border-color ${({ theme }) => theme.motion.fast} ease,
    box-shadow ${({ theme }) => theme.motion.fast} ease;

  &::placeholder {
    color: ${({ theme }) => theme.colors.ink4};
  }

  &:hover:not(:disabled):not(:focus) {
    border-color: ${({ theme }) => theme.colors.inputBorderHover};
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.ink};
    box-shadow: ${({ theme }) => theme.shadows.focus};
  }

  &:read-only {
    background: ${({ theme }) => theme.colors.bgLayout};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: ${({ theme }) => theme.textMobile.lg};
  }
`
export default RemarkModal
